module.exports = __webpack_public_path__ + "media/7.56fe0ca9.mp3";